import widgetFactory from '../widgetFactory';

export const widgetName = 'tooltipMessage';

let widget = widgetFactory(widgetName, {
  options: {
    text: null,
    message: 'foo',
  },

  _create: function () {
    this._super(widgetName);

    this.element.addClass('tooltipMessage').html(this.options.message);
  },
});

export default widget;
